export default class Analytics {
	/**
	 * See https://wiki.apnic.net/x/QoZb for related GTM configuration.
	 *
	 * @param {String} pageURL
	 * @param {Function|null} then - (optional) Method to be called once dataLayer is updated successfully.
	 */
	static trackPageView({ pageURL, then = null }) {

		let data = {
			event: "createGAPageView",
			pageURL: pageURL,
			// "eventCallback" is a standard GTM Data Layer feature to provide a hook for after data layer is updated.
			eventCallback: function () {
				if (then !== null) {
					then();
				}
			}
		};

		if (window.dataLayer !== undefined) {
			// See https://developers.google.com/tag-manager/reference#datalayerpush
			window.dataLayer.push(data);

		} else {
			// Ensure we continue even if GTM is not able to be updated.
			if (then !== null) {
				then();
			}
		}
	}
}
